import {changeEvent, dispatchCustomEvent} from "../../../../../webpack/modules/events";
import {trackProductPageGa4Events} from "../../../../../webpack/modules-optimized/product";
import {hideOffcanvas} from "../../../../../webpack/modules-optimized/offcanvas";
import {hideOptionErrors, updatePriceElements} from "../../../../../webpack/modules-optimized/product-page";

changeEvent('#product-page input[name="drop"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let drops = offcanvas.querySelectorAll('.drop');
    let drop = element.nextElementSibling;

    dispatchCustomEvent(
        'productTissueDropChanged',
        {
            'option': offcanvas,
            'previewElement': previewElement,
        }
    );
    drops.forEach((drop) => drop.classList.remove('selected'));
    drop.classList.add('selected');
    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    hideOptionErrors(offcanvas);
    hideOffcanvas(offcanvas.id);
    updatePriceElements(container);
    trackProductPageGa4Events('BlindDrop', element.dataset.preview);
});